import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './CoachingDiary.css';
import coachingdiaryimage from '../../assets/pageimages/CoachingDiary.webp';

function CoachingDiaryHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Coaching Diary</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/coachingdiary-studentlist" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="coachingdiary-bottomlink-style" />My Students</Link></div>
            <div className="bottom-buttons-box"><Link to="/coachingdiary-mypractice" className="top-button-link"><FontAwesomeIcon icon={faStar} className="coachingdiary-bottomlink-style" />My Practice</Link></div>
            <div className="bottom-buttons-box"><Link to="/coachingdiary-coachfeedback" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="coachingdiary-bottomlink-style" />Practice Feedback</Link></div>
            <div className="bottom-buttons-box"><Link to="/coachingdiary-matchdayreport" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="coachingdiary-bottomlink-style" />Matchday Report</Link></div>
            <div className="bottom-buttons-box"><Link to="/coachingdiary-coachdiary" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="coachingdiary-bottomlink-style" />Coach Diary</Link></div>
          </div>
        </div>
        <div className="image-container">
          <div className="relative inset-0 flex border border-b-gray-300">
            <img id="coachingdiary-id" src={coachingdiaryimage} alt="CoachingDiary Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default CoachingDiaryHome;
